"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToggleFavoriteButton_1 = require("./components/ToggleFavoriteButton");
exports.ToggleFavoriteButton = ToggleFavoriteButton_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-favorites/lib/index.js
// module id = 1721
// module chunks = 46 105